import React from 'react';
import PropTypes from 'prop-types';

export default class AccountMenu extends React.Component {
  static propTypes = {
    className: PropTypes.string
  };

  render() {
    let classNameArray = [ 'account-menu' ];
    if (this.props.className) classNameArray.push(this.props.className);

    return (
      <ul className={classNameArray.join(' ')}>
        {this.props.children}
      </ul>
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/views/user/AccountMenu.js
 **/